import axios from 'axios'
import {API_URL} from '../constants';

const REPORT_API_URL = `${API_URL}/statistic`;

class StatisticService {

    getGhiLoiStatistics() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${REPORT_API_URL}/getGhiLoiStatistics`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    getErrorReportStatistics(fromDate, toDate, worker, errorGroup, errorDetails, reporter) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${REPORT_API_URL}/getErrorReportStatistics`, {fromDate: fromDate, toDate: toDate, errorGroup: errorGroup, worker: worker, errorDetails: errorDetails, reporter: reporter},
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    getErrorReportStatisticsByDays(fromDate, toDate, worker, errorGroup, errorDetails, reporter) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${REPORT_API_URL}/getErrorReportStatisticsByDays`, {fromDate: fromDate, toDate: toDate, errorGroup: errorGroup, worker: worker, errorDetails: errorDetails, reporter: reporter},
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    getShipPackageStatistic(shipCode) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${REPORT_API_URL}/getShipPackageStatistics`, { shipCode: shipCode},
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    getKiemTraHq(shipCode) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${REPORT_API_URL}/getKiemTraHq`, { shipCode: shipCode},
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    getShipPackageStatisticForBasket(shipCode) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${REPORT_API_URL}/getShipPackageStatisticsForBasket`, { shipCode: shipCode},
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }      
}

export default new StatisticService()